import React from 'react';
import PropTypes from 'prop-types';
import { US_STATES } from '../../../helpers/locationAbbrevHelper';

export default class States extends React.PureComponent {
    constructor() {
        super();
        this.getStates = this.getStates.bind(this);
    }
    getStates(){
        const stateOptions = [];
        US_STATES.map((value) => {
            const key = `state-${value.value}`;
            const r = (
                <option value={value.value} key={key}>
                    {value.label}
                </option>
            );
            return stateOptions.push(r);
        });
        return stateOptions;
    }
    render() {
        return (
            <select
                id="state"
                name="state"
                className={this.props.className}
                defaultValue={this.props.account.home_address.state || ''}
                onChange={this.props.handleChange}>
                {this.getStates()}
            </select>
        );
    }
}

States.propTypes = {
    className: PropTypes.string,
    account: PropTypes.shape({
        account_id: PropTypes.string,
        email: PropTypes.string,
        first_name: PropTypes.string,
        home_address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            city: PropTypes.string,
            country: PropTypes.string,
            state: PropTypes.string,
            zip_code: PropTypes.string
        }),
        home_phone: PropTypes.string,
        last_name: PropTypes.string
    }),
    handleChange: PropTypes.func
};

